import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getOtherProps, widthClass, GRID_WIDTHS } from '../util';
import IconSet from './IconSet';

var FooterLinkList = /*#__PURE__*/function (_Component) {
  _inherits(FooterLinkList, _Component);

  function FooterLinkList() {
    _classCallCheck(this, FooterLinkList);

    return _possibleConstructorReturn(this, _getPrototypeOf(FooterLinkList).apply(this, arguments));
  }

  _createClass(FooterLinkList, [{
    key: "renderLink",
    value: function renderLink(link, key) {
      var linkClassName = classNames('wds-c-footer-section__content', {
        'wds-c-footer-section__content--align-right': link.props.alignRight
      }, {
        'wds-c-footer__contact-links': link.props.social
      }, _defineProperty({}, "".concat(widthClass(this.props.listItemsWidth)), this.props.listItemsWidth !== undefined));

      if (this.props.topicTitle) {
        return React.createElement("li", {
          key: key
        }, link);
      }

      return React.createElement("li", {
        key: key,
        className: linkClassName
      }, link);
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var _this = this;

      return React.Children.map(this.props.children, function (child, index) {
        return child && _this.renderLink(child, index);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var otherProps = getOtherProps(FooterLinkList.propTypes, this.props);
      var navLinkClassName = classNames('wds-c-unstyled-list', _defineProperty({}, "".concat(widthClass(this.props.listSectionWidth)), this.props.listSectionWidth !== undefined), {
        'wds-c-footer-section__content': this.props.topicTitle
      });
      return React.createElement("ul", _extends({}, otherProps, {
        className: navLinkClassName
      }), this.props.topicTitle && React.createElement("li", {
        className: "wds-c-footer__primary-link"
      }, React.createElement(IconSet, {
        className: "wds-c-accordion-chevron",
        decorative: true,
        name: "chevron-up"
      }), React.createElement("h4", null, this.props.topicTitle)), this.renderList());
    }
  }]);

  return FooterLinkList;
}(Component);

export { FooterLinkList as default };
FooterLinkList.propTypes = {
  /**  the children to the FooterLinkList */
  children: PropTypes.node,

  /**  Width of the Footer Link List Group Section */
  listSectionWidth: PropTypes.oneOf(GRID_WIDTHS),

  /**  Width of the Footer Link List Items Section */
  listItemsWidth: PropTypes.oneOf(GRID_WIDTHS),

  /**  Topic Title for the Link List Group */
  topicTitle: PropTypes.string
};
FooterLinkList.defaultProps = {
  children: undefined,
  listSectionWidth: undefined,
  listItemsWidth: undefined,
  topicTitle: undefined
};